import { isVideoArticlePage, isWebView } from '../../utils/aem-utils';

export const multipleVideoPlaylistModule = {
  name: 'Multiple Video Playlist',
  shouldInit: () => !isWebView() && !isVideoArticlePage(),
};
